import { ReactNode } from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import type { SxProps, Theme } from '@mui/material/styles';

interface SubsectionHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  note?: ReactNode;
  sx?: SxProps<Theme>;
}

export default function SubsectionHeader({
  title,
  description,
  note,
  sx,
}: SubsectionHeaderProps) {
  return (
    <Stack gap={0.5} sx={sx}>
      <Typography variant="body1" fontWeight={600}>
        {title}
      </Typography>

      {description && <Typography variant="caption">{description}</Typography>}

      {note && (
        <Stack direction="row" alignItems="center" gap={1}>
          <InfoOutlined color="info" sx={{ fontSize: 14 }} />
          <Typography variant="caption" pt={0.25}>
            {note}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
}
